import React from 'react'
import HighlightIcon from '@mui/icons-material/Highlight';


export default function Header() {
  return (
    <header>
          <h1 className='header'>
           <HighlightIcon/> Kepper App
        </h1>
    </header>
  )
}

